var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79647 8.26109C5.89689 8.16149 5.97659 8.04299 6.03098 7.91244C6.08537 7.78188 6.11338 7.64185 6.11338 7.50042C6.11338 7.35898 6.08537 7.21895 6.03098 7.08839C5.97659 6.95784 5.89689 6.83934 5.79647 6.73975L0.878896 1.83289C0.778479 1.73329 0.698775 1.61479 0.644383 1.48424C0.589991 1.35368 0.561988 1.21365 0.561988 1.07222C0.561988 0.930783 0.589991 0.790749 0.644383 0.660193C0.698775 0.529637 0.778479 0.411143 0.878896 0.311545C1.07963 0.112002 1.35117 0 1.63421 0C1.91725 0 2.18879 0.112002 2.38952 0.311545L7.3071 5.22912C7.90899 5.83176 8.24707 6.64868 8.24707 7.50042C8.24707 8.35216 7.90899 9.16907 7.3071 9.77171L2.38952 14.6893C2.18997 14.8872 1.92063 14.9988 1.63957 15C1.49857 15.0008 1.35879 14.9738 1.22826 14.9205C1.09773 14.8671 0.979005 14.7886 0.878896 14.6893C0.778479 14.5897 0.698775 14.4712 0.644383 14.3406C0.589991 14.2101 0.561988 14.07 0.561988 13.9286C0.561988 13.7872 0.589991 13.6471 0.644383 13.5166C0.698775 13.386 0.778479 13.2675 0.878896 13.1679L5.79647 8.26109Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.72496e759ba9ae75b450eea609bdf760.svg";
export { ForwardRef as ReactComponent };